import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceShare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVoiceShare"><Path d="M8.5 21H7V3H8.5V21Z" fill="currentColor"/><Path d="M21 17.5H19.5V14.4775C18.4455 15.5234 17.8529 16.4181 17.5088 17.2783C17.0663 18.3846 17 19.5088 17 21H15.5C15.5 19.4913 15.5588 18.1154 16.1162 16.7217C16.5438 15.6528 17.2458 14.6175 18.3555 13.5H15.5V12H21V17.5Z" fill="currentColor"/><Path d="M12.75 17H11.25V7H12.75V17Z" fill="currentColor"/><Path d="M4.5 15H3V9H4.5V15Z" fill="currentColor"/><Path d="M17 10H15.5V5H17V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceShare;
